import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function SolarFuelsUseCase() {
  return (
    <>
    <section
      id="solar-fuels"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Solar Fuels
          </h1>
          <p className="text-slate-300 space-y-2">
            Solar fuels represent a transformative approach to sustainable energy by converting sunlight into chemical energy — often in the form of hydrogen, carbon-based fuels, or ammonia.
            These fuels are generated through photoelectrochemical or photocatalytic reactions, where organic or hybrid materials act as light absorbers and catalysts to drive reactions like water splitting or CO₂ reduction.

            <br /><br />

            Designing effective solar fuel systems requires precise control over light absorption, redox properties, band alignment, and catalytic activity.
            Organic chromophores and donor–acceptor systems are increasingly explored as sensitisers or active catalysts due to their tunability, earth-abundance, and compatibility with scalable fabrication methods.
          </p>
        </div>

        {/* How Apoello Helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Search a curated database for molecules with redox potentials matched to hydrogen evolution and CO₂ reduction reactions.
    </li>
    <li>
      Identify light-harvesters with strong visible/NIR absorption and excited-state lifetimes.
    </li>
    <li>
      Explore charge-transfer character, exciton dissociation, and orbital alignment with semiconductors or co-catalysts.
    </li>
    <li>
      Access frontier orbital energetics and excited-state thermodynamics to evaluate photochemical reactivity.
    </li>
  </ul>
</div>
        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            Solar fuels offer a route to store renewable energy in chemical form — enabling long-term storage and carbon-neutral fuels.
            However, progress is limited by slow material discovery and poor reaction efficiencies. DiaDEM™ speeds up innovation by helping researchers digitally prototype chromophores and catalysts — before synthesis — accelerating discovery and reducing cost.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
